import React from 'react';
import Reveal from './Reveal';

const AboutSection = ({ t }) => (
    <section id="about" className="relative bg-white py-16 md:py-24 border-t border-line">
        <div className="sk-container">
            {/* Header */}
            <Reveal className="max-w-[640px] mb-12">
                <p className="sk-eyebrow">{t('about-subtitle')}</p>
                <h2 className="mt-3 font-heading font-bold text-primary-deep text-[clamp(1.6rem,3.5vw,2.4rem)] leading-tight">
                    {t('about-title')}
                </h2>
            </Reveal>

            <div className="grid grid-cols-1 md:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14 items-start">
                {/* Portrait + credential */}
                <Reveal variant="left" className="relative mx-auto w-full max-w-[380px] md:sticky md:top-24">
                    <div className="overflow-hidden rounded-[var(--sk-radius-lg)] shadow-[var(--sk-shadow-2)] border border-line bg-primary-soft">
                        <img
                            src="/sara2.png"
                            alt="RD. Sara Khedr in clinic"
                            width="380"
                            height="460"
                            loading="lazy"
                            className="w-full h-auto object-cover"
                        />
                    </div>
                    <div className="absolute -bottom-5 inset-x-4 bg-primary-deep text-white rounded-2xl px-5 py-3.5 shadow-[var(--sk-shadow-2)] flex items-center gap-3">
                        <i className="fas fa-graduation-cap text-gold text-lg" aria-hidden="true" />
                        <span className="text-[0.82rem] font-medium leading-snug">{t('credential-degree')}</span>
                    </div>
                </Reveal>

                {/* Story */}
                <div>
                    <Reveal delay={80}>
                        <p className="text-ink-soft text-[1.05rem] leading-relaxed">{t('about-intro')}</p>
                        <p className="mt-4 text-ink-soft text-[1.05rem] leading-relaxed">{t('about-approach')}</p>
                    </Reveal>

                    {/* Qualifications */}
                    <Reveal delay={140} className="mt-9">
                        <h3 className="font-heading font-semibold text-primary-deep text-[1.1rem] mb-4">
                            {t('expertise-title')}
                        </h3>
                        <ul className="list-none m-0 p-0 grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {[t('qual-masters'), t('qual-sports'), t('qual-transformations'), t('qual-weight')].map(
                                (qual) => (
                                    <li
                                        key={qual}
                                        className="sk-card flex items-start gap-3 px-4 py-3.5 !rounded-2xl"
                                    >
                                        <i className="fas fa-check-circle text-secondary mt-0.5 flex-shrink-0" aria-hidden="true" />
                                        <span className="text-[0.92rem] text-ink font-medium leading-snug">{qual}</span>
                                    </li>
                                )
                            )}
                        </ul>
                    </Reveal>

                    {/* Signature pull-quote */}
                    <Reveal delay={200} className="mt-10">
                        <figure className="relative m-0 ps-6 border-s-4 border-secondary">
                            <blockquote className="m-0 font-heading font-medium text-primary-deep text-[clamp(1.05rem,1.8vw,1.3rem)] leading-relaxed italic">
                                “{t('quote-text')}”
                            </blockquote>
                            <figcaption className="mt-3 text-ink-soft font-semibold text-[0.9rem]">
                                {t('quote-author')}
                            </figcaption>
                        </figure>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);

export default AboutSection;
